import { httpservice } from '../services';
import { constants } from '../constant/constant';

const doManageTwoFAForUser = (isEnabled) => httpservice()
  .post(isEnabled ? constants.API.ENABLE_TWO_FA : constants.API.DISABLE_TWO_FA)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export default doManageTwoFAForUser;
